import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * AuthGuard - Enforces that an authenticated user session is active.
 * If no session is present, redirects the user to /login and preserves
 * the attempted destination URL for post-login return.
 */
export default function AuthGuard({ children }) {
  const location = useLocation();
  const { user, isLoggedIn } = useSelector((state) => state.auth || {});

  let hasStoredUser = false;
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && (parsed.accessToken || parsed.token || parsed.access_token || parsed.username)) {
        hasStoredUser = true;
      }
    }
  } catch (e) {
    hasStoredUser = false;
  }

  const authenticated = Boolean(isLoggedIn || user || hasStoredUser);

  if (!authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
}
